import { makeStyles } from '@material-ui/core/styles';

const font = {
    fontFamily: 'Varela Round, sans-serif, Regular',
    color: '#F2F2F2', //'#011E23',
    letterSpacing: 0,
    opacity: 1,
};

export const useAnonymousFileEditStyles = makeStyles({
    
    holder: {
        width: 'inherit',
    },

    fileHolder: {
        width: '-webkit-fill-available',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#011E23 0% 0% no-repeat padding-box', // '#FCFCFC 0% 0% no-repeat padding-box',
        border: '1px solid #FCFCFC', //'1px solid #011E23',
        borderRadius: '12px',
        opacity: 1,
        marginTop: '48px',
        padding: '20px',
    },

    addFile: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },

    addButton: {
        ...font,
        fontSize: '12px',
        color: '#FFFFFF', //'#011E23',
        opacity: 1,
        borderRadius: '12px',
        textTransform: 'unset',
        paddingBottom: '4px',
        paddingTop: '4px',
        marginTop: '16px',
        marginBottom: '16px',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: '#A9AAAB', //'transparent',
            color: '#011E23',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },

    },

    cancelButton: {
        ...font,
        fontSize: '16px',
        color: '#FFFFFF',
        opacity: 1,
        borderRadius: '12px',
        width: '132px',
        textTransform: 'unset',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: '#A9AAAB', //'transparent',
            color: '#011E23',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
    },

});

export const imageStyle = { 
    width: '300px',
    height: '225px',
    objectFit: 'cover',
};

export const caracterStyle = { 
    // color: '#A9AAAB',
    color: '#F2F2F2',
    opacity: '0.45',
};
